const browserList = [
	{ title: 'firefox', icon: 'fab fa-firefox-browser' },
	{ title: 'chrome', icon: 'fab fa-chrome' },
	{ title: 'safari', icon: 'fab fa-safari' },
	{ title: 'edge', icon: 'fab fa-edge' },
];

const DetectBrowserIcon = (browserName?: string) => {
	if (!browserName) return 'fas fa-window-maximize';
	const found = browserList.find(
		(e) => e.title.toLowerCase() === browserName.toLowerCase()
	);
	if (found) {
		return found.icon;
	}
	return 'fas fa-window-maximize';
};

export default DetectBrowserIcon;
